module.exports = __webpack_public_path__ + "media/王者荣耀MV.1d58fb62.mp4";